import { SmartpowerLocation } from 'src/app/global/types';
import { Injectable } from '@angular/core';
import EbrService from "./ebr.service";
import {FiltersService} from "./filters.service";
import {Filters} from "../../global/filter-model";
import {Router} from "@angular/router";
import {SmartPowerSummary} from "../../global/smartpower-types";
import {AlertService} from "./alert.service";
import {Alert} from "../../global/types";
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SmartpowerService {

  constructor(private ebrService: EbrService,
    private userService: UserService,
    private filtersService: FiltersService,
    private alertService: AlertService,
    private router: Router) { }

  async getSummaryData(): Promise<SmartPowerSummary | undefined> {
    let filters: Filters = new Filters();
    this.filtersService.filtersConfirmed.subscribe(f => filters = f);
    const username = this.userService.getUsername();

    if (filters.regions == undefined) {
      await this.router.navigateByUrl('/filter');
      const alert: Alert = {
        id: Math.random() * 25,
        message:
          'No filters selected. Please select filters before navigating to SMARTPOWER',
      };
      this.alertService.addAlert(alert);
      return undefined;
    }

    try {
      // TODO: Consider not sending the username as it is now available in the access token sent to the API
      const { data } = await this.ebrService.getSmartpowerSummary(username, filters);
      return data;
    }
    catch(error: any) {
      console.log(error);

      let errMsg: string = '';
      if (
        error.response.data ==
        'Must have at least one row of asset to account data to retrieve SMARTPOWER results'
      ) {
        errMsg =
          'There are no connected devices to the selected accounts. Please select accounts that have connected devices and try again';
      } else {
        errMsg = error.response.data;
      }

      const alert: Alert = {
        id: Math.random() * 25,
        message: errMsg,
      };
      this.alertService.addAlert(alert);

      return undefined;
    }
  }

  async getLocationData(metric: string): Promise<SmartpowerLocation[] | undefined> {
    let filters: Filters = new Filters();
    this.filtersService.filtersConfirmed.subscribe((f) => (filters = f));

    try {
      const { data } = await this.ebrService.getSmartpowerLocation(filters, metric);
      return data;
    }
    catch(error: any) {
      console.log(error);

      let errMsg: string = '';
      if (
        error.response.data ==
        'Must have at least one row of asset to account data to retrieve SMARTPOWER results'
      ) {
        errMsg =
          'There are no connected devices to the selected accounts. Please select accounts that have connected devices and try again';
      } else {
        errMsg = error.response.data;
      }

      const alert: Alert = {
        id: Math.random() * 25,
        message: errMsg,
      };
      this.alertService.addAlert(alert);

      return undefined;
    }
  }
}
